<template>
  <div class="artwork-content">
    <article>
      <div
        v-html="artwork.content"
        :style="{ backgroundColor: artwork.background_color }"
      />
    </article>
    <div
      :key="application.invite"
      class="p-3"
      v-for="application in artwork.inviteapplication_set"
    >
      Submission to
      <router-link :to="`/goodluck/${application.invite}/`">{{
        application.title
      }}</router-link>
    </div>
    <div class="status d-flex justify-content-between p-3">
      <div class="cc d-flex justify-content-around">
        <font-awesome-icon
          :icon="['fab', 'creative-commons-by']"
          size="2x"
          color="white"
        />
        <font-awesome-icon
          :icon="['fab', 'creative-commons-nc']"
          size="2x"
          color="white"
        />
        <font-awesome-icon
          :icon="['fab', 'creative-commons-nd']"
          size="2x"
          color="white"
        />
      </div>
      <social
        name="artwork"
        :target="artwork"
        class="social d-flex justify-content-around"
      ></social>
    </div>
    <div class="author">
      <div class="p-3">
        <author :author="artwork.author" variant="dark" />
      </div>
      <div class="card-container d-flex flex-wrap justify-content-center">
        <artwork
          :key="artwork.id"
          :artwork="artwork"
          :class="i >= 4 ? 'd-card' : null"
          new-window
          v-for="(artwork, i) in artworks.results.filter(
            a => a.id != $route.params.artwork
          )"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ArtworkComponent from "./Artwork";
import Author from "./Author";
import Social from "./Social";
import { Artwork } from "../models";

export default {
  components: {
    Artwork: ArtworkComponent,
    Author,
    Social
  },
  props: ["artwork"],
  data() {
    return {
      artworks: {
        results: []
      }
    };
  },
  watch: {
    "artwork.author.id": {
      async handler(id) {
        this.artworks = await new Artwork().byUser(id);
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ article {
  > div {
    padding: 0 40px;
  }

  hr {
    width: 80%;
  }

  iframe {
    max-width: 100%;
    border: none;
  }

  .no-padding {
    max-width: calc(100% + 80px) !important;
    margin: 0 -40px !important;
  }

  .img-percent {
    display: block;
    margin: 0 auto !important;

    @media only screen and (max-width: 900px) {
      width: 900px !important;
    }
  }
}

.status {
  background-color: black;
}

.cc svg {
  margin: 0 5px;
}

.author {
  background-color: #1f1f1f;
  padding-bottom: 50px;

  .card-container {
    overflow: hidden;

    @media (min-width: 512px) {
      max-height: 544px;
    }

    .card {
      margin: 7.5px;
      max-width: calc(50% - 15px);

      &.d-card {
        display: none;

        @media (min-width: 512px) {
          display: block;
        }
      }
    }
  }
}
</style>
